// material-ui
'use client'
import { Link, Typography, Stack, Grid, Button } from '@mui/material';
import { useState } from 'react';
import { useIntl } from "react-intl";
import { useTheme } from "@mui/styles";
import ContactDevelopers from '@/app/global-functions/ContactDevelopers';
import { Box } from '@mui/system';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const AuthFooter = () =>  {
    const intl = useIntl();
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const theme = useTheme();
    const textColor = theme.palette.mode === 'dark' ? 'white' : theme.palette.text.primary;
    
    const updateApp = () => {
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload();
        }
      }

    
  return (
    <>
    <Stack direction="row" justifyContent="space-between">
        <Typography style={{color:textColor}}  variant="subtitle2" 
        component={Link} href="https://futurissvision.com" target="_blank" underline="hover">
            FUTURISS  - {process.env.NEXT_PUBLIC_VERSION}
        </Typography>
       {/*  <Typography style={{color:textColor}} variant="subtitle2" 
        component={Link} href="https://futurissvision.com" 
        target="_blank" underline="hover">
            &copy; FUTURISS INC.- {process.env.NEXT_PUBLIC_VERSION}
        </Typography> */}

       {/*  <Typography style={{color:textColor}} variant="subtitle2" 
        component={Link} href="https://futurissvision.com" 
        target="_blank" underline="hover">
          developers
            &copy;futurissvision.com
        </Typography>
 */}

<Box
      sx={{
        textAlign: 'center',
        padding: '16px',
      }}
    >
      <ContactDevelopers />
    </Box>
    </Stack>
    </>
);
  }

export default AuthFooter;



/* function UpdateModal({ isOpen, onClose, onUpdate }) {
    if (!isOpen) return null;
  
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '5px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}>
          <p>Update do Futuriss - Dipanda Click para actualizar</p>
          <button onClick={onUpdate}>Update</button>
          <button onClick={onClose}>Fechar</button>
        </div>
      </div>
    );
} */
